import { render, staticRenderFns } from "./home-division.vue?vue&type=template&id=c60d9680&scoped=true&"
import script from "./home-division.vue?vue&type=script&lang=js&"
export * from "./home-division.vue?vue&type=script&lang=js&"
import style0 from "./home-division.vue?vue&type=style&index=0&id=c60d9680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60d9680",
  null
  
)

export default component.exports